export default __webpack_public_path__ + "static/media/Galaxis.2ce1e236.svg";